import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";


const metricasPorMotivosDeturnos = async ({ params,token, callbacks }) => {
    const response = await connection({ method: 'POST', url: `${ENTITY_URL.SUPERVISOR.METRICAS.MOTIVOS_TURNO}`, extraHeaders: { token: token } , params: params });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}

export default metricasPorMotivosDeturnos;